import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomValidators } from '@narik/custom-validators';
import { KeyValuePair, ValidationMessage } from '@tymes4-shared';

export interface CreatePaymentRequestDialogData {
  title?: string;
  titleParams?: Object;
  message?: string;
  messageParams?: Object;
  email?: string;
  emailLabel?: string;
  okBtnText?: string;
  cancelBtnText?: string;
}

export interface CreatePaymentRequestDialogResult {
  confirmed: boolean;
  email?: string;
}

@Component({
    selector: 'app-create-payment-request-dialog',
    templateUrl: './create-payment-request-dialog.component.html',
    standalone: false
})
export class CreatePaymentRequestDialogComponent implements OnInit {

  public form!: FormGroup;
  public validationMessages: KeyValuePair<ValidationMessage[]> = {};

  public okBtnText = 'BTN.OK';
  public cancelBtnText = 'BTN.CANCEL';

  constructor(
    public dialogRef: MatDialogRef<CreatePaymentRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreatePaymentRequestDialogData
  ) {
    if (data.okBtnText) {
      this.okBtnText = data.okBtnText;
    }
    if (data.cancelBtnText) {
      this.cancelBtnText = data.cancelBtnText;
    }
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      Email: new FormControl(this.data.email || '', [Validators.required, CustomValidators.email])
    });
  }

  close(confirmed: boolean): void {
    if (confirmed && this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const result: CreatePaymentRequestDialogResult = {
      confirmed: confirmed,
      email: this.form.get('Email')?.value
    };
    this.dialogRef.close(result);
  }
}

